var products_on_page = $(".products-on-page");

    
  var load_more_btn = $(".load-more__button");
  var load_more_spinner = $(".load-more__spinner");
function loadMoreProducts(url_to_load) {
  
      
console.log(url_to_load);


$.ajax({
  url:url_to_load,
   type:'GET',
     beforeSend: function(){
      load_more_btn.hide();
      load_more_spinner.show();
      
      },
   success: function(data){
     load_more_spinner.hide();
    load_more_btn.hide();


    $('.load-more').html($(data).find('.load-more a'));
   
    $('.products-on-page').append($(data).find('.products-on-page').html());
     
     
   }
});



  }
window.loadMoreProducts = loadMoreProducts;